import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = 768;
const TABLET_BREAKPOINT = 1024;

/**
 * Returns the device information based on the screen width.
 * @returns {{
 * deviceType: 'desktop' | 'tablet' | 'mobile',
 * isMobile: boolean,
 * isTablet: boolean,
 * isDesktop: boolean,
 * screenWidth: number,
 * screenHeight: number,
 * orientation: 'portrait' | 'landscape'
 * }}
 */
export const useDevice = () => {
  const [deviceInfo, setDeviceInfo] = useState({
    deviceType: 'desktop',
    isMobile: false,
    isTablet: false,
    isDesktop: true,
    screenWidth: 1200,
    screenHeight: 800,
    orientation: 'portrait',
  });

  useEffect(() => {
    // Run only once on component mount
    const width = window.innerWidth;
    const height = window.innerHeight;

    let deviceType = 'desktop';
    if (width <= MOBILE_BREAKPOINT) {
      deviceType = 'mobile';
    } else if (width <= TABLET_BREAKPOINT) {
      deviceType = 'tablet';
    }

    const orientation = width > height ? 'landscape' : 'portrait';

    setDeviceInfo({
      deviceType,
      isMobile: deviceType === 'mobile',
      isTablet: deviceType === 'tablet',
      isDesktop: deviceType === 'desktop',
      screenWidth: width,
      screenHeight: height,
      orientation,
    });
  }, []);

  return deviceInfo;
};